<template>
  <div class="absolute bottom-8 mx-auto justify-center items-center opacity-80 z-30" :class="{
    ['hidden']: !visible,
    ['hidden sm:flex']: visible,
  }">
    <div class="animate-bounce">
      <svg class="h-6 w-6 text-neutral" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
let timeoutId: any
const visible = ref(false)

const onScroll = (): void => {
  const threshold = window.innerHeight * 0.5
  const scrollPoint = window.scrollY

  if (scrollPoint >= threshold) {
    window.removeEventListener('scroll', onScroll)
    visible.value = false

    if (!timeoutId === undefined) {
      return
    }
    window.clearTimeout(timeoutId)
  }
}

onMounted(() => {
  timeoutId = setTimeout(() => visible.value = true, 10_000)
  const listenerId = window.addEventListener('scroll', onScroll)
})
</script>

<style>
@keyframes bounce {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-25%);
  }
}

.animate-bounce {
  animation: bounce 3s infinite;
}
</style>
